var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Tinymce',{attrs:{"height":300,"placeholder":"在这里输入文字"},model:{value:(_vm.defaultValue),callback:function ($$v) {_vm.defaultValue=$$v},expression:"defaultValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }